import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

class ShoppingCartStepOne extends React.Component {
  render() {
    return (
      <div className="col">
        <div className="d-flex p-2 rounded" style={{backgroundColor: 'black'}}>
          <div onClick={() => { this.props.changeStep(0, true); }} className="pl-2 pr-2 pointer">
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>

          <p className="m-0 text-center" style={{ flex: 1 }}>Step 1 of 3: Select Program</p>
        </div>
      </div>
    );
  }
}

export default ShoppingCartStepOne;
